import { Injectable, TemplateRef } from '@angular/core';
import { FormControl } from '@angular/forms';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { BehaviorSubject, distinctUntilChanged } from 'rxjs';

@UntilDestroy()
@Injectable()
export class SideDetailViewService<Output = unknown, Data = unknown> {
  private readonly sidenavOpened$$ = new BehaviorSubject(false);
  readonly sidenavOpened$ = this.sidenavOpened$$.asObservable().pipe(distinctUntilChanged(), untilDestroyed(this));

  private readonly titleString$$ = new BehaviorSubject('');
  readonly titleString$ = this.titleString$$.asObservable().pipe(distinctUntilChanged(), untilDestroyed(this));

  private readonly titleFormControl$$ = new BehaviorSubject<FormControl<string> | null>(null);
  readonly titleFormControl$ = this.titleFormControl$$
    .asObservable()
    .pipe(distinctUntilChanged(), untilDestroyed(this));

  private resolve?: (value?: Output | PromiseLike<Output>) => void;
  private readonly data$$ = new BehaviorSubject<Data | null>(null);

  private readonly footer$$ = new BehaviorSubject<TemplateRef<unknown> | null>(null);
  readonly footer$ = this.footer$$.pipe();

  readonly data$ = this.data$$.asObservable().pipe(untilDestroyed(this));

  async open(data?: Data): Promise<Output | undefined> {
    return new Promise<Output | undefined>((resolve) => {
      this.resolve = resolve;
      this.data$$.next(data ?? null);
      this.sidenavOpened$$.next(true);
    }).then((value) => {
      this.sidenavOpened$$.next(false);
      return value;
    });
  }

  close(value?: Output) {
    if (!this.resolve) {
      throw new Error('SideDetailViewRef#resolve not found');
    }

    this.resolve(value);
    this.sidenavOpened$$.next(false);
  }

  setSideDetailViewTitle(value: string | FormControl<string>) {
    if (typeof value === 'string') {
      this.titleString$$.next(value);
    } else {
      this.titleFormControl$$.next(value);
    }
  }

  setFooter(templateRef: TemplateRef<unknown> | null) {
    this.footer$$.next(templateRef);
  }
}
